import { renderWithLoader, useForm, useMutation } from '@meteor/data-hooks';
import { Button, Dialog, Input, showModal, Spacer } from '@meteor/ui';
import { Table, TextField } from '@radix-ui/themes';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { adminAgentsState } from '../../state';

export let AgentsPage = () => {
  let [after, setAfter] = useState<string | undefined>();
  let [search, setSearch] = useState<string | undefined>();

  let adminAgents = adminAgentsState.use({
    search,
    after
  });

  return renderWithLoader({ adminAgents })(({ adminAgents }) => (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 15,
          marginBottom: 20
        }}
      >
        <form
          style={{ flex: 1 }}
          onSubmit={e => {
            e.preventDefault();
            let formData = new FormData(e.target as HTMLFormElement);
            let search = formData.get('search') as string;
            setSearch(search);
          }}
        >
          <TextField.Root placeholder="Search" name="search" defaultValue={search} />
        </form>
      </div>

      <Table.Root variant="surface">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Slug</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Is Template</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Created At</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell></Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {adminAgents.data.map(agent => (
            <Table.Row key={agent.id}>
              <Table.Cell>{agent.name}</Table.Cell>
              <Table.Cell>{agent.slug}</Table.Cell>
              <Table.Cell>{agent?.template ? 'Yes' : 'No'}</Table.Cell>
              <Table.Cell>{agent.createdAt.toLocaleDateString('de-at')}</Table.Cell>
              <Table.Cell>
                {agent?.template ? (
                  <Link to={`/agents/${agent.template.id}`}>
                    <Button as="span" size="1">
                      View Template
                    </Button>
                  </Link>
                ) : (
                  <Button
                    size="1"
                    onClick={() =>
                      showModal(({ dialogProps, close }) => {
                        let create = useMutation(adminAgents.mutators.create);

                        let form = useForm({
                          initialValues: {
                            name: '',
                            description: '',
                            slug: ''
                          },
                          onSubmit: async values => {
                            let [res] = await create.mutate({ ...values, agentId: agent.id });
                            if (res) close();
                          },
                          schema: yup =>
                            yup.object({
                              name: yup.string().required(),
                              description: yup.string().required(),
                              slug: yup.string().required()
                            })
                        });

                        return (
                          <Dialog.Wrapper {...dialogProps}>
                            <Dialog.Title>Create Template</Dialog.Title>

                            <form {...dialogProps} onSubmit={form.handleSubmit}>
                              <Input label="Name" {...form.getFieldProps('name')} />
                              <form.RenderError field="name" />

                              <Spacer size={15} />

                              <Input
                                minRows={5}
                                label="Description"
                                {...form.getFieldProps('description')}
                              />
                              <form.RenderError field="description" />

                              <Spacer size={15} />

                              <Input label="Slug" {...form.getFieldProps('slug')} />
                              <form.RenderError field="slug" />

                              <Spacer size={15} />

                              <Button
                                type="submit"
                                loading={create.isLoading}
                                success={create.isSuccess}
                              >
                                Create
                              </Button>
                              <create.RenderError />
                            </form>
                          </Dialog.Wrapper>
                        );
                      })
                    }
                  >
                    Create Template
                  </Button>
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

      <Button
        size="1"
        style={{ marginTop: 20 }}
        onClick={() => setAfter(adminAgents.data[adminAgents.data.length - 1]?.id)}
      >
        Load More
      </Button>
    </>
  ));
};
